import produce from 'immer';

import {renameEvent} from 'common/report/util/events';
import {customEventsStore} from 'common/report/stores/custom-events';

import {Event, EventItem, SerializedEventItemKeyMap} from './types';

export function filterToBookmarkableEventItem(item: EventItem): Event {
  return produce(item, (itemDraft: EventItem): void => {
    for (const key in itemDraft) {
      if (!SerializedEventItemKeyMap[key]) {
        delete itemDraft[key];
      }
    }
  });
}

export function getEventSelectedLabel(
  selected: Event,
  {
    labelPrefix,
    includeNameOnRename = false,
  }: {
    labelPrefix?: string;
    includeNameOnRename?: boolean;
  } = {},
) {
  if (!selected) {
    return ``;
  }

  const {renamed, label} = selected;
  let selectedLabel = ``;

  // handle custom event loading
  if (selected.id && selected.custom) {
    selectedLabel = selected.label || customEventsStore.value[selected.id]?.name || `Loading...`;
  } else {
    selectedLabel = label || renameEvent(selected.value);
  }

  if (renamed) {
    selectedLabel = includeNameOnRename ? `${renamed} (${selectedLabel})` : renamed;
  }

  selectedLabel = labelPrefix ? `${labelPrefix} ${selectedLabel}` : selectedLabel;

  return selectedLabel;
}
